import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { FEATURES } from "@/pages/marketing/data";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay },
});

export default function Features() {
  const navigate = useNavigate();

  return (
    <main data-testid="features-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 sm:pt-28 pb-16">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="max-w-3xl">
          <p className="text-sm font-semibold tracking-[0.15em] uppercase text-[#D4AF37]">Features</p>
          <h1 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0A1633] leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="features-heading">
            One membership. Every advantage.
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Each part of Castles exists to make your student life easier, richer and more enjoyable. Explore what members unlock.
          </p>
        </motion.div>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-24 sm:pb-32">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map((f, i) => (
            <motion.button
              key={f.slug}
              {...fade((i % 3) * 0.07)}
              data-testid={`feature-card-${f.slug}`}
              onClick={() => navigate(`/features/${f.slug}`)}
              className="text-left bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-3xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
            >
              <div className="relative">
                <img src={f.image} alt={f.title} className="w-full aspect-[16/9] object-cover" loading="lazy" />
                <div className="absolute bottom-4 left-4 w-11 h-11 rounded-xl bg-white shadow-md flex items-center justify-center">
                  <f.icon className="w-6 h-6" style={{ color: f.color }} strokeWidth={1.5} />
                </div>
              </div>
              <div className="p-7">
                <h3 className="text-xl font-semibold text-[#0A1633]" style={{ fontFamily: "'Outfit', sans-serif" }}>{f.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed">{f.cardCopy}</p>
                <p className="mt-4 text-sm font-medium flex items-center gap-1.5" style={{ color: f.color }}>
                  Learn more <ArrowRight className="w-4 h-4" />
                </p>
              </div>
            </motion.button>
          ))}
        </div>
      </section>
    </main>
  );
}
